import { combineReducers } from "redux";

import authReducer from "./Auth";
import usersReducer from "./user";
import insuranceReducer from "./Insurance";
import unApprovedInsurance from "./unApprovedInsurance";
import approvedInsurance from "./approvedInsurance";
import RenewInsurance from "./RenewInsurance";
import monthly from "./monthly";
import loaded from "./loaded";
export default combineReducers({
  auth: authReducer,
  users: usersReducer,
  insurance: insuranceReducer,
  unApprovedInsurance,
  approved: approvedInsurance,
  renew: RenewInsurance,
  monthly,
  loaded,
});
